import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "@coveord/plasma-mantine";
import { Controller } from "react-hook-form";
export var RHFCheckbox = function(_param) {
    var control = _param.control, externalOnBlur = _param.onBlur, externalOnChange = _param.onChange, restProps = _object_without_properties(_param, [
        "control",
        "onBlur",
        "onChange"
    ]);
    /*#__PURE__*/ return _jsx(Controller, {
        control: control,
        name: restProps.name,
        render: function(_param) {
            var _field = _param.field, value = _field.value, onBlur = _field.onBlur, onChange = _field.onChange, fieldState = _param.fieldState, restField = _object_without_properties(_param.field, [
                "value",
                "onBlur",
                "onChange"
            ]);
            var ref;
            /*#__PURE__*/ return _jsx(Checkbox, _object_spread(_object_spread_props(_object_spread({
                checked: value
            }, restField), {
                error: (ref = fieldState.error) === null || ref === void 0 ? void 0 : ref.message,
                onBlur: function(event) {
                    externalOnBlur === null || externalOnBlur === void 0 ? void 0 : externalOnBlur(event);
                    onBlur();
                },
                onChange: function(event) {
                    externalOnChange === null || externalOnChange === void 0 ? void 0 : externalOnChange(event);
                    onChange(event);
                }
            }), restProps));
        }
    });
};
RHFCheckbox.Group = Checkbox.Group;

//# sourceMappingURL=RHFCheckbox.js.map